import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';


import { LoginComponent } from './views/login/login.component';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,  
  
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';
import { DxToolbarModule, DxDrawerModule, DxListModule, DxTreeViewModule, DxTreeListModule, DxFormModule, DxPopupModule, DxButtonModule, DxLookupModule, DxChartModule, DxNumberBoxModule, DxPieChartModule, DxSelectBoxModule, DxTextBoxModule, DxBoxModule, DxTextAreaModule, DxDataGridModule, DxDateBoxModule } from 'devextreme-angular';
import { CommonComponetsModule } from './views/common/common.module';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { SettingsGuard } from './auth-guards/settings-auth-guard';
import { MaintenanceGuard } from './auth-guards/maintenance-auth-guard';
import { ReportsGuard } from './auth-guards/reports-auth-gaurd';
import { ResourceCentreGuard } from './auth-guards/resource-centre-auth-guard';
import { CommunicationGuard } from './auth-guards/communication-auth-guard';
import { TransportGuard } from './auth-guards/transport-auth-guard';
import { AccomodationGuard } from './auth-guards/accomodation-auth-guard';
import { ExamsGuard } from './auth-guards/exams-auth-guarg';
import { FeesGuard } from './auth-guards/fees-auth-guard';
import { StudentsGuard } from './auth-guards/students-auth-guard';
import { AdministrationGuard } from './auth-guards/administration-auth-guard';
import { LoggedInGuard } from './auth-guards/logged-in-auth-guard';
import { ConfigService } from './config-service';
import { TimetableGuard } from './auth-guards/timetable-auth-guard';
import {SimpleNotificationsModule} from 'angular2-notifications';
import { eLearningGuard } from './auth-guards/elearning-auth-guard';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { StudentLoggedInGuard } from './auth-guards/student_portal_guard';
import { ParentsLoginComponent } from './views/parents-portal/parents-login/parents-login/parents-login.component';
import { ParentsPortalGuard } from './auth-guards/parents-portal-auth-guard';
import { ResetPasswordComponent } from './views/parents-portal/reset-password/reset-password/reset-password.component';
import { OnlineApplicationFormComponent } from './views/online-application-form/online-application-form/online-application-form.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    DxToolbarModule,
    DxDrawerModule,
    DxListModule,
    DxTreeViewModule,
    DxTreeListModule,
    HttpClientModule,
    DxFormModule,
    DxPopupModule,
    DxButtonModule,
    DxLookupModule,
    DxToolbarModule,
    DxListModule,
    DxTreeViewModule,
    DxTreeListModule,
    HttpClientModule,
    DxFormModule,
    DxPopupModule,
    DxButtonModule,
    DxChartModule,
    DxPieChartModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    CommonComponetsModule,
    DxLookupModule,
    DxBoxModule,
    DxTextAreaModule,
    DxDataGridModule,
    DxDateBoxModule,
    SimpleNotificationsModule.forRoot(),
    BackButtonDisableModule.forRoot(
      {
        preserveScrollPosition: true
      }
    )
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    ParentsLoginComponent,
    ResetPasswordComponent,
    OnlineApplicationFormComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,
    SettingsGuard,
    MaintenanceGuard,
    ReportsGuard,
    ResourceCentreGuard,
    CommunicationGuard,
    TransportGuard,
    AccomodationGuard,
    ExamsGuard,
    FeesGuard,
    StudentsGuard,
    AdministrationGuard,
    TimetableGuard,
    LoggedInGuard,
    eLearningGuard,
    StudentLoggedInGuard,
    ParentsPortalGuard,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigurations,
      deps: [ConfigService], // dependancy
      multi: true
    },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }

export function loadConfigurations(configService: ConfigService) {
  return () => configService.loadConfig();
}

